const removeTypenameKey = obj => {
  const { __typename, ...rest } = obj;

  return rest;
};

export const mapResourceSkillDetailsToSkillParameters = resourceSkill =>
  resourceSkill.skillAssignments.map(skillAssignment => ({
    skillUri: skillAssignment.uri,
    name: skillAssignment.displayText,
    skillLevelUri: skillAssignment.skillLevel.uri,
    certificate: skillAssignment.certificate,
    skillCustomMetadata: skillAssignment.skillCustomMetadata.map(
      removeTypenameKey
    ),
    category: {
      id: resourceSkill.category.uri,
      name: resourceSkill.category.displayText
    }
  }));

export const combineResourceSkillDetails = ({
  existingResourceSkillDetails,
  newResourceSkillDetails,
  mergeSkills
}) => {
  const combinedCategoryMap = existingResourceSkillDetails.reduce(
    (acc, resourceSkillDetails) => {
      acc[resourceSkillDetails.category.displayText.toLowerCase()] = {
        category: resourceSkillDetails.category,
        skillAssignments: resourceSkillDetails.skillAssignments.reduce(
          (accumulator, skillAssignment) => {
            accumulator[
              skillAssignment.displayText.toLowerCase()
            ] = skillAssignment;

            return accumulator;
          },
          {}
        )
      };

      return acc;
    },
    {}
  );

  newResourceSkillDetails.forEach(resourceSkillDetails => {
    const { category, skillAssignments } = resourceSkillDetails;

    skillAssignments.forEach(skill => {
      let existingCategoryMap =
        combinedCategoryMap[category.displayText.toLowerCase()];

      if (!existingCategoryMap) {
        combinedCategoryMap[category.displayText.toLowerCase()] = {
          category,
          skillAssignments: {}
        };
        existingCategoryMap =
          combinedCategoryMap[category.displayText.toLowerCase()];
      }

      existingCategoryMap.skillAssignments[
        skill.displayText.toLowerCase()
      ] = mergeSkills(
        existingCategoryMap.skillAssignments[skill.displayText.toLowerCase()],
        skill
      );
    });
  });

  return Object.values(combinedCategoryMap).map(categoryMap => ({
    category: categoryMap.category,
    skillAssignments: Object.values(categoryMap.skillAssignments)
  }));
};
